import { Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarItem } from '@app/app/shared/models/sidebar/sidebar.model';
import { StyleguideModule } from '@app/app/shared/styleguide/styleguide.module';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'ptl-sidebar-expandable-children',
  standalone: true,
  imports: [RouterModule, StyleguideModule, TranslocoModule],
  templateUrl: './sidebar-expandable-children.component.html',
  styleUrls: ['./sidebar-expandable-children.component.scss'],
})
export class SidebarExpandableChildrenComponent {
  children = input<SidebarItem[]>([]);
  pageSize = input(10);

  childClick = output<{ item: SidebarItem; event: Event }>();

  onChildClick(event: Event, item: SidebarItem): void {
    this.childClick.emit({ item, event });
  }
}
